import sortBy from 'lodash/sortBy'
import Factor from '../entities/factor'
import { map } from '../update'
import { isFactorVisible } from '../config/visible'
import { getFactorCategoryOrder, getFactorOrder } from '../config/order'
import { getFactors, getFactorSeries } from '../actions/factors'

const FactorsAggregateStore = {
  getInitialState() {
    return []
  },

  reset(_, { factors }) {
    // configuration determines visibility regardless of data
    let visible = factors.filter(isFactorVisible)

    // sort factors by configuration: region, then category,
    // then by index in categoryList factors array for the region
    let sorted = sortBy(visible, [
      'Region',
      getFactorCategoryOrder,
      getFactorOrder
    ])

    return sorted.map(item => new Factor(item))
  },

  addSeries(factors, dataPoints) {
    const ID = dataPoints[0].ID

    return map(factors, function(factor) {
      if (factor.ID === ID) {
        return factor.update({ dataPoints })
      }

      return factor
    })
  },

  setLoading(factors, id) {
    return map(factors, function(factor) {
      if (factor.ID === id) {
        return factor.update({ loading: true })
      }

      return factor
    })
  },

  register() {
    return {
      [getFactors.done]: this.reset,
      [getFactorSeries.done]: this.addSeries,
      [getFactorSeries.open]: this.setLoading
    }
  },

  deserialize(factors) {
    return this.reset(null, { factors: factors || [] })
  }
}

export default FactorsAggregateStore



// WEBPACK FOOTER //
// ./src/domains/factors.js